import {useState} from 'react'
import {useFetchBuilderReference} from '@/builder/hooks/useFetchBuilderReference'
import {useFetchOneEntry} from 'hec/hooks/useFetchOneEntry'
import modelMap from 'hec/builder/model-map'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

export const useSelectedGoalData = () => {
    const config = getConfig()
    const [goal, setGoal] = useState(null)
    const {dashboard, benefits, id: goalId} = goal || {}

    const shouldQueryDashboard = !!goal && !dashboard?.value
    const shouldQueryBenefits = goal ? !!benefits?.find(({benefit}) => !benefit?.value) : false

    const {id: dashboardId, model: dashboardModel} = dashboard || {}

    const {
        data: dashboardData,
        isLoading: isDashboardDataLoading,
        error: dashboardDataError
    } = useFetchBuilderReference({
        model: dashboardModel,
        referenceId: dashboardId,
        shouldQuery: shouldQueryDashboard,
        fields: 'data.url'
    })

    const {
        data: benefitsData,
        isLoading: isBenefitsDataLoading,
        error: benefitsDataError
    } = useFetchOneEntry({
        queryKey: [`questionnaire-goal-benefits`, goalId],
        options: {
            model: modelMap.learningCenterGoal,
            apiKey: config.app.builder.api,
            query: {data: {id: goalId}},
            fields: 'data.benefits'
        },
        enabled: shouldQueryBenefits
    })

    if (dashboardDataError) {
        console.error(
            `An error occurred while fetching goal dashboard data for goal ${goal?.name}: `,
            dashboardDataError
        )
    }
    if (benefitsDataError) {
        console.error(
            `An error occurred while fetching goal benefits data for goal ${goal?.name}: `,
            benefitsDataError
        )
    }

    if (shouldQueryDashboard && dashboardData && !isDashboardDataLoading && !dashboardDataError) {
        setGoal((prevGoal) => ({
            ...prevGoal,
            dashboard: {...prevGoal?.dashboard, value: {data: dashboardData.data}}
        }))
    }

    if (shouldQueryBenefits && benefitsData && !isBenefitsDataLoading && !benefitsDataError) {
        setGoal((prevGoal) => ({
            ...prevGoal,
            benefits: benefitsData.data.benefits
        }))
    }

    return {goal, setGoal}
}
